enum UserItemFilter {
  MaxItemsOnSale = 'MaxItemsOnSale',
  Collectibles = 'Collectibles',
  Created = 'Created',
}

export default UserItemFilter;
